<div class="new-feature-container fx-layout-row">
  <div class="new-feature-tilted-box">
    {{ 'LABEL.NEW_FEATURE'| translate }}

  </div>
  <div class="new-feature-message">
        {{ message }}
  </div>
  <div class="fx-flex"></div>
  <div class="fx-layout-col">
    <button (click)="dismiss()" class="close-button">
      <i class="mdi mat-icon mdi-close"></i>
    </button>
      <button (click)="reloadPage()" class="reload-button" [matTooltip]="'BUTTON.LOAD_NEW_VERSION' | translate"
              matTooltipPosition="below">
      <i class="mdi mat-icon mdi-reload"></i>
    </button>
  </div>
</div>
